import { render, staticRenderFns } from "./SchoolTOSModal.vue?vue&type=template&id=4be23fd7&"
import script from "./SchoolTOSModal.vue?vue&type=script&lang=js&"
export * from "./SchoolTOSModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports